import React, {FC, useState} from 'react';
import s from './Templates.module.css';
import facebook_icon from '../../../../assets/img/facebook.svg';
import linkedin_icon from '../../../../assets/img/linkedin.svg';
import instagram_icon from '../../../../assets/img/instagram.svg';
import twitter_icon from '../../../../assets/img/twitter.svg';
// import reddit_icon from '../../../../assets/img/reddit.svg';
// import threads_icon from '../../../../assets/img/threads.svg';
import {setCurrentTemplate, Template} from "../../../../store/slices/templatesSlice";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../../store/store";


interface TemplatesProps {
    currentTemplate: Template|null
}


const Templates: FC<TemplatesProps> = ({ currentTemplate }) => {
    const dispatch = useDispatch<AppDispatch>();
    const templates: Template[] = [
        { id: '1', title: 'Facebook Post', icon: facebook_icon, tag: 'facebook' },
        { id: '2', title: 'Linkedin Post', icon: linkedin_icon,  tag: 'linkedin' },
        { id: '3', title: 'Instagram Post', icon: instagram_icon, tag: 'instagram' },
        { id: '4', title: 'Twitter Post', icon: twitter_icon, tag: 'twitter' },
        // { id: '5', title: 'Reddit Post', icon: reddit_icon, tag: 'reddit' },
        // { id: '6', title: 'Threads Post', icon: threads_icon, tag: 'threads' },
    ];

    const handleTemplateSelection = (template:Template) => {
        dispatch(setCurrentTemplate(template));

    };
    return (
        <div className={s.templates_container}>
            {templates.map((template) => (
                <div className={s.background}>
                    <div
                        key={template.id}
                        onClick={() => handleTemplateSelection(template)}
                        className={`${s.template_card} ${s[template.tag]}  ${currentTemplate?.id === template.id ? s[`${template.tag}_active`] : ''}`}

                    >
                        <img
                            src={template.icon}
                            alt={template.title}
                            className={s.template_image}
                        />
                        <span className={s.template_title}>{template.title}</span>
                    </div>
                </div>

            ))}
        </div>
    );
};

export default Templates;
